module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("Also by the same author,")])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_c('span', [_vm._v("IMPERIAL HIGHNESS")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("CURSE NOT THE KING")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("FAR FLY THE EAGLES")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84056688","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter.vue
// module id = 60
// module chunks = 0